import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

export enum ViewAllSource {
    RecommendedLots = 'Recommended lots',
    SavedLots = 'Saved lots',
}

type TrackViewAllClickedPayload = TrackingPayload & { carouselContent: ViewAllSource };

export const trackViewAllClicked = (payload: TrackViewAllClickedPayload) => {
    track(TrackingEvents.Browse.ViewAllClicked, payload);
};

export const useTrackViewAllClicked = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        (carouselContent: ViewAllSource) => {
            trackViewAllClicked({
                carouselContent,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
